<template>
    <div>
        <recaptcha v-if="$config.recaptcha.enabled" />
        <button
            :disabled="disabled"
            type="submit"
            class="button button--primary button--full-width"
            @click="verifyToken"
        >
            <LoadingIndicator v-if="loading" />
            <template v-else>
                {{ label }}
            </template>
        </button>
    </div>
</template>

<script>
import LoadingIndicator from '~/components/LoadingIndicator';
export default {
    name: 'RecaptchaButton',
    components: { LoadingIndicator },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        isInvalid: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            required: true,
        },
    },
    methods: {
        verifyToken() {
            this.$emit('start-verifying');

            this.$nextTick(async () => {
                if (this.isInvalid) {
                    this.$emit('error');

                    return;
                }

                if (!this.$config.recaptcha.enabled) {
                    this.$emit('success', null);

                    return;
                }

                try {
                    const token = await this.$recaptcha.getResponse();
                    this.$emit('success', token);
                } catch (error) {
                    this.$emit('error');
                    this.$sentry.captureException(error);
                }
            });
        },
    },
};
</script>

<style scoped></style>
